module.exports = __webpack_public_path__ + "media/images/redesign-images/collegiate/college-store/ohio-university-83e29d65561d16499c610c476247f5ce.jpg";